import { Component } from 'react';
import { Link } from 'react-router-dom';
import { listCities } from '../../../../../../insfrastructure/services/cities';
import { StaticValues } from '../../../../../../insfrastructure/services/static_values';
import { createCandidate } from '../../../../../../insfrastructure/services/candidates';
import { retrievePostcodeInfo } from '../../../../../../insfrastructure/services/cep';
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component';
import { ErrorMessage, emptyField, errorsLength, formatErrors, validateCEP, validateDate, validatePasswordConfirmation } from '../../../../../../insfrastructure/utils/form-validators';
import { omitEmpty } from '../../../../../../insfrastructure/utils/object-utils';
import { formatUnitName } from '../../../../../../insfrastructure/utils/unit-formatter';
import { Input } from '../../../../../components/input';
import { Select } from '../../../../../components/select';
import { DateOfBirthField } from '../../../../../components/date-of-birth-field';
import RadioInput from '../../../../../components/radio';
import CheckboxInput from '../../../../../components/checkbox';
import { SubmitBtn } from '../../../../../components/submit';
import ResponseModal from '../../../../../components/response-modal';
import { PasswordRequirements } from '../../../../../components/password-requirements';
import { formatDateOnly } from '../../../../../../insfrastructure/utils/date-formatter';
import candidateImg from '../../../../../../assets/images/candidate.png';
import './styles.sass';

class CandidateForm extends Component<RouterProps> {
  state: any = {
    form: {
      "full_name": "",
      "cpf": "",
      "email": "",
      "mobile": "",
      "date_of_birth": "",
      "password": "",
      "gender": "",
      "marital_status": "",
      "salary_expectation": '0',
      "city_id": 0,
      "postcode": "",
      "address": "",
      "address_number": "",
      "address_district": "",
      "address_complement": "",
      "city_uf": "",
      "escola_do_mecanico_id": null,
      "terms_and_conditions": false
    },
    formErrors: {},
    loading: false,
    loadingCityOptions: false,
    cityOptions: [],
    em_units: [],
    cities: [],
    genderOptions: [],
    maritalStatusOptions: []
  }
  citiesSearchTimeout: any = null

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
  
      const em_units = Object.values(staticValues.em_unit)
        .map((x: any) => {
          const { formatted, nameOnly } = formatUnitName(x.name);
          return { value: x.branch_number, label: formatted, nameOnly };
        })
        .sort((a, b) => a.nameOnly.localeCompare(b.nameOnly, 'pt-BR', { sensitivity: 'base' }))
        .map(({ value, label }) => ({ value, label }));
      const genderOptions = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
      const maritalStatusOptions = Object.keys(staticValues.marital_status).map((key: any) => ({ value: key, label: staticValues.marital_status[key] }));
  
      this.setState({ em_units, genderOptions, maritalStatusOptions });
    } catch (error) {}
  }

  onCityNameSearch = async (e: any, no_timeout?: boolean) => {
    clearTimeout(this.citiesSearchTimeout);

    // Validação: verificar se e existe e é uma string válida
    if (!e || typeof e !== 'string' || e.length < 3) {
      return;
    };

    this.setState({ loadingCityOptions: true }, async () => {
      this.citiesSearchTimeout = setTimeout(async () => {
        const cities = (await listCities(e));
        const cityOptions = cities.map(x => ({ value: parseInt(x.id+''), label: x.displayName }));

        this.setState({ cities, cityOptions, loadingCityOptions: false });
      }, no_timeout ? 0 : 1000);
    });
  }

  timeout: any = null

  onCEPChange = async (value: any) => {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(async () => {
      let result: any = null;

      if(validateCEP(value) === '') {
        try {
          result = await retrievePostcodeInfo(value);
        } catch (error) {
          this.setState({
            responseData: {
              type: 'error',
              title: 'CEP Inválido',
              text: ''
            }
          });

          return;
        };

        // Validação: garantir que result.cidade existe antes de chamar onCityNameSearch
        if (result.cidade && typeof result.cidade === 'string') {
          await this.onCityNameSearch(result.cidade, true);

          if (result.city_id) {
            setTimeout(() => {
              this.onSelectCity(result.city_id);
            }, 1000);
          }
        }

        // Preencher campos de endereço automaticamente
        if (result) {
          this.setState({
            form: {
              ...this.state.form,
              address: result.logradouro || '',
              address_district: result.bairro || '',
              city_uf: result.uf || ''
            }
          });
        }
      };
    }, 1000);
  }

  onSelectCity = async (city_id: any) => {
    const city = this.state.cities.find((x: any) => x.id === city_id+'');

    this.setState({
      form: {
        ...this.state.form,
        city_id,
        city_uf: city ? city.uf : ''
      }
    });
  }

  scrollToFirstError = () => {
    const firstErrorElement = document.querySelector('.errors .error') as HTMLElement | null;
    if (firstErrorElement && typeof firstErrorElement.scrollIntoView === 'function') {
      firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  onSubmit = async () => {
    if (this.state.loading) return;

    let form = {
      ...this.state.form,
      cpf: this.state.form.cpf.replace(/[.-]/g,""),
      date_of_birth: this.state.form.date_of_birth ? (formatDateOnly(this.state.form.date_of_birth) ?? undefined) : undefined,
      skills: []
    };

    // Converter city_id para número
    if (form.city_id) {
      form.city_id = parseInt(form.city_id, 10);
    }

    // Converter escola_do_mecanico_id para número se necessário
    if (form.escola_do_mecanico_id) {
      form.escola_do_mecanico_id = parseInt(form.escola_do_mecanico_id, 10);
    }

    // Converter salary_expectation para número
    if (form.salary_expectation !== undefined && form.salary_expectation !== null && form.salary_expectation !== '') {
      const salaryValue = typeof form.salary_expectation === 'string' 
        ? parseFloat(form.salary_expectation.replace(/[^\d.,]/g, '').replace(',', '.'))
        : form.salary_expectation;
      form.salary_expectation = isNaN(salaryValue) ? 0 : salaryValue;
    }

    // Remover escola_do_mecanico_id se não for estudante
    if (this.state.form.is_studant !== 'yes') {
      delete form.escola_do_mecanico_id;
    }

    // Remover campos que não devem ser enviados ao backend
    delete form.city_uf;
    delete form.terms_and_conditions;
    delete form.is_studant;
    delete form.password_confirmation;

    // Aplicar omitEmpty após limpar campos
    form = omitEmpty(form);

    let errorsValidations: any = {
      full_name: [emptyField(form.full_name, 'string')], 
      // full_name: [emptyField(form.full_name, 'string'), validateRegex(this.state.form.full_name, /^[A-Za-z0-9@/./+/-/\-_]+$/, 'Nome do usuário inválido')], 
      cpf: [emptyField(form.cpf, 'string')], 
      email: [emptyField(form.email, 'string')], 
      mobile: [emptyField(form.mobile, 'string')], 
      date_of_birth: [emptyField(form.date_of_birth, 'string'), form.date_of_birth ? validateDate(form.date_of_birth) : ''], 
      password: [emptyField(form.password, 'string')], 
      password_confirmation: [emptyField(this.state.form.full_name, 'string'), validatePasswordConfirmation(this.state.form.password, this.state.form.password_confirmation)], 
      gender: [emptyField(form.gender, 'string')], 
      marital_status: [emptyField(form.marital_status, 'string')], 
      salary_expectation: [emptyField(form.salary_expectation, 'number')], 
      postcode: [emptyField(form.postcode, 'string')],
      address_number: [emptyField(form.address_number, 'string')],
      city_id: [emptyField(form.city_id, 'number')],
      terms_and_conditions: [emptyField(this.state.form.terms_and_conditions)]
    };

    if (this.state.form.is_studant === 'yes') {
      errorsValidations['escola_do_mecanico_id'] = [emptyField(form.escola_do_mecanico_id, 'number')];
    }

    const errors = formatErrors(errorsValidations);

    this.setState({ formErrors: errors }, () => {
      if (errorsLength(errors) > 0) {
        this.scrollToFirstError();
      }
    });

    if(errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

    try {
      this.setState({ loading: true });

      await createCandidate(form as any);

      setTimeout(() => {  
        this.setState({ loading: false });
        this.props.navigate('/sign-up/candidate/confirmation/request', { state: { email: form.email } });
      });
    } catch (error: any) {
      let errors: string[] = [];

      // Verificação segura: só acessa error.response.data se existir
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        // Erros de email duplicado
        if (errorData['email']) {
          errors.push('Email já cadastrado');
        }

        // Erros de nome duplicado
        if (errorData['full_name']) {
          errors.push('Nome já cadastrado');
        }

        // Erros de CPF
        if (errorData['cpf']) {
          const cpfError = Array.isArray(errorData['cpf']) 
            ? errorData['cpf'][0] 
            : errorData['cpf'];
          errors.push(`CPF: ${cpfError}`);
        }

        // Erros de city_id
        if (errorData['city_id']) {
          const cityError = Array.isArray(errorData['city_id']) 
            ? errorData['city_id'][0] 
            : errorData['city_id'];
          errors.push(`Cidade: ${cityError}`);
        }

        // Erros de escola_do_mecanico_id
        if (errorData['escola_do_mecanico_id']) {
          const escolaError = Array.isArray(errorData['escola_do_mecanico_id']) 
            ? errorData['escola_do_mecanico_id'][0] 
            : errorData['escola_do_mecanico_id'];
          errors.push(`Escola do Mecânico: ${escolaError}`);
        }

        // Erros de skills
        if (errorData['skills']) {
          const skillsError = Array.isArray(errorData['skills']) 
            ? errorData['skills'][0] 
            : errorData['skills'];
          errors.push(`Habilidades: ${skillsError}`);
        }

        // Erros de salary_expectation
        if (errorData['salary_expectation']) {
          const salaryError = Array.isArray(errorData['salary_expectation']) 
            ? errorData['salary_expectation'][0] 
            : errorData['salary_expectation'];
          errors.push(`Expectativa salarial: ${salaryError}`);
        }

        // Capturar outros erros de validação
        Object.keys(errorData).forEach(key => {
          if (!['email', 'full_name', 'cpf', 'city_id', 'escola_do_mecanico_id', 'skills', 'salary_expectation'].includes(key)) {
            const errorValue = errorData[key];
            if (Array.isArray(errorValue)) {
              errorValue.forEach((err: string) => {
                if (!errors.includes(err)) {
                  errors.push(err);
                }
              });
            } else if (typeof errorValue === 'string') {
              if (!errors.includes(errorValue)) {
                errors.push(errorValue);
              }
            }
          }
        });
      }

      // Se não há erros específicos da API, mostrar mensagem genérica
      if (errors.length === 0) {
        errors.push('Erro ao processar cadastro. Tente novamente.');
      }

      let responseData = {
        type: 'error',
        title: 'Erro ao cadastrar',
        text: () => <>
          { errors.map((error, index) => <p key={index}>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    };
  }

  render() {
    return (
      <div className='candidate-sign-up-form'>
        <h3>Dados Candidato</h3>
        <div className='columns'>
          <div className='column'>
          <Input
            name='full_name'
            label='Nome completo'
            value={this.state.form['full_name']}
            onChange={e => this.setState({ form: { ...this.state.form, full_name: e }, formErrors: { ...this.state.formErrors, full_name: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['full_name']} />
            <Input
            name='email'
            label='Email'
            value={this.state.form['email']}
            onChange={e => this.setState({ form: { ...this.state.form, email: e }, formErrors: { ...this.state.formErrors, email: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['email']} />
            <DateOfBirthField
            name='date_of_birth'
            label='Data Nascimento'
            value={this.state.form['date_of_birth']}
            onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e }, formErrors: { ...this.state.formErrors, date_of_birth: [] } })}
            errors={this.state.formErrors['date_of_birth']} />
            <Select
            name='marital_status'
            label='Estado Civil'
            value={this.state.form['marital_status']}
            options={this.state.maritalStatusOptions}
            onChange={e => this.setState({ form: { ...this.state.form, marital_status: e }, formErrors: { ...this.state.formErrors, marital_status: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['marital_status']} />
            <Input
            name='postcode'
            label='CEP'
            mask='99999-999'
            value={this.state.form.postcode}
            onChange={e => {this.setState({ form: { ...this.state.form, postcode: e }, formErrors: { ...this.state.formErrors, postcode: [] } }); this.onCEPChange(e)}} />
            <ErrorMessage errors={this.state.formErrors['postcode']} />
            <Input
            name='address'
            label='Endereço'
            value={this.state.form.address}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address: e }, formErrors: { ...this.state.formErrors, address: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['address']} />
            <Input
            name='address_number'
            label='Número'
            value={this.state.form.address_number}
            onChange={e => this.setState({ form: { ...this.state.form, address_number: e }, formErrors: { ...this.state.formErrors, address_number: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['address_number']} />
            <Input
            name='password'
            label='Senha'
            type='password'
            value={this.state.form.password}
            onChange={e => this.setState({ form: { ...this.state.form, password: e }, formErrors: { ...this.state.formErrors, password: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['password']} />
            <PasswordRequirements
            password={this.state.form.password}
            email={this.state.form.email}
            isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}/>
            <div className='terms-and-conditions-container'>
              <CheckboxInput
              name='terms_and_conditions'
              label={
                () => (
                  <div>
                    Aceito a{' '}
                    <Link 
                      to='/privacy-policy' 
                      target='_blank' 
                      rel='noopener noreferrer'
                      style={{ color: '#FFD700', textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Política de Privacidade
                    </Link>
                  </div>
                )
              }
              checked={this.state.form.terms_and_conditions}
              onChange={e => this.setState({ form: { ...this.state.form, terms_and_conditions: e }, formErrors: { ...this.state.formErrors, terms_and_conditions: [] } })}/>
              <ErrorMessage errors={this.state.formErrors['terms_and_conditions']} />
            </div>
          </div>
          <div className='column'>
            <Input
            name='cpf'
            label='CPF'
            value={this.state.form['cpf']}
            onChange={e => this.setState({ form: { ...this.state.form, cpf: e }, formErrors: { ...this.state.formErrors, cpf: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['cpf']} />
            <Input
            name='mobile'
            label='Celular'
            mask='(99) 99999-9999'
            value={this.state.form['mobile']}
            onChange={e => this.setState({ form: { ...this.state.form, mobile: e }, formErrors: { ...this.state.formErrors, mobile: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['mobile']} />
            <Select
            name='gender'
            label='Gênero'
            value={this.state.form['gender']}
            options={this.state.genderOptions}
            onChange={e => this.setState({ form: { ...this.state.form, gender: e }, formErrors: { ...this.state.formErrors, gender: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['gender']} />
            <Input
            name='salary_expectation'
            label='Pretensão Salarial'
            type='money'
            value={this.state.form['salary_expectation']}
            onChange={e => this.setState({ form: { ...this.state.form, salary_expectation: e }, formErrors: { ...this.state.formErrors, salary_expectation: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['salary_expectation']} />
            <Select
            name='city_id'
            label='Cidade'
            options={this.state.cityOptions}
            value={this.state.form.city_id}
            readonly={true}
            hasSearch={true}
            onSearchChange={e => this.onCityNameSearch(e)}
            loading={this.state.loadingCityOptions}
            onChange={e => {this.setState({ form: { ...this.state.form, city_id: e }, formErrors: { ...this.state.formErrors, city_id: [] } }); this.onSelectCity(e);}}/>
            <ErrorMessage errors={this.state.formErrors['city_id']} />
            <Input
            name='address_district'
            label='Bairro'
            value={this.state.form.address_district}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address_district: e }, formErrors: { ...this.state.formErrors, address_district: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['address_district']} />
            <Input
            name='city_uf'
            label='Estado'
            value={this.state.form.city_uf}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, city_uf: e }, formErrors: { ...this.state.formErrors, city_uf: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['city_uf']} />
            <Input
            name='password_confirmation'
            label='Confirmar Senha'
            type='password'
            onChange={e => this.setState({ form: { ...this.state.form, password_confirmation: e }, formErrors: { ...this.state.formErrors, password_confirmation: [] } })}/>
            <ErrorMessage errors={this.state.formErrors['password_confirmation']} />
          </div>
          <div className='column'>
            <img src={candidateImg} alt='candidate' />
            <RadioInput
            name='is_studant'
            label='Aluno da Escola do Mecânico?'
            options={[
              {
                label: 'Sim',
                value: 'yes'
              },
              {
                label: 'Não',
                value: 'no'
              }
            ]}
            onChange={e => this.setState({ form: { ...this.state.form, is_studant: e, escola_do_mecanico_id: 0 } })}/>
            {this.state.form.is_studant === 'yes' &&
            <>
              <Select
              name='escola_do_mecanico_id'
              label='Unidade da Escola do Mecânico'
              placeholder='Unidade da Escola do Mecânico'
              value={this.state.form['escola_do_mecanico_id']}
              options={this.state.em_units}
              onChange={e => this.setState({ form: { ...this.state.form, escola_do_mecanico_id: e }, formErrors: { ...this.state.formErrors, escola_do_mecanico_id: [] } })}/>
              <ErrorMessage errors={this.state.formErrors['escola_do_mecanico_id']} />
            </>}
          </div>
        </div>
        <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
      </div>
    )
  }
}

export const CandidateFormWithRouter = withRouter(CandidateForm);